import { FC, useContext } from 'react';

import { ResumeCardActionsContext } from 'src/components/ResumeCard/Actions/Context';
import { VIEW_WITHOUT_CONTACTS } from 'src/utils/constants/resumePermission';

import InviteButton from 'src/components/ResumeCard/Actions/InviteButton';

const InviteButtonWrapper: FC<{ isMobile?: boolean }> = ({ isMobile }) => {
    const { resume } = useContext(ResumeCardActionsContext);
    const inviteUrl = resume.negotiationLinks?.invite.defaultLink;
    const inviteToAnotherUrl = resume.negotiationLinks?.inviteAnother.defaultLink;
    const inviteLinks = resume.negotiationLinks?.invite.stateLinks;

    if (resume._attributes.permission === VIEW_WITHOUT_CONTACTS || !inviteUrl || !inviteToAnotherUrl) {
        return null;
    }

    return (
        <InviteButton
            inviteUrl={inviteUrl}
            inviteToAnotherUrl={inviteToAnotherUrl}
            inviteLinks={inviteLinks}
            isMobile={isMobile}
        />
    );
};

export default InviteButtonWrapper;
